export default class SoundManager {

    sounds = {}
    isMute = false

    constructor() {

    }

    add(name, sound) {
        this.sounds[name] = sound
    }

    toggleMute() {
        this.isMute = !this.isMute
        Object.keys(this.sounds).forEach(
            (name) => {
                this.sounds[name].mute = this.isMute
            }
        )
    }

    play(sound) {
        if (this.sounds[sound]) {
            this.sounds[sound].play()
        }
    }
}
